var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _rect, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect2, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAatreya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 66,
    viewBox: "0 0 225 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1427 7.21033H80.4805L82.8171 9.42186L86.2158 23.0167L86.9206 27.2214L90.1796 47.2324H83.8904L82.7469 39.2851V39.3995H75.6001L74.4566 47.2324H68.6248L75.1427 7.21033ZM82.0036 33.9679L79.2021 14.1856H79.0877L76.3434 33.9679H82.0036Z",
    fill: "#EB0014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3698 7.21033H106.889L113.407 47.2324H107.117L105.974 39.2851V39.3995H98.8272L97.6837 47.2324H91.8519L98.3698 7.21033ZM105.231 33.9679L102.429 14.1856H102.315L99.5704 33.9679H105.231Z",
    fill: "#EB0014"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.751 12.9278H112.176V7.21033H131.615V12.9278H125.04V47.2324H118.751V12.9278Z",
    fill: "#EB0014"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.66 7.21033H143.979C147.219 7.21033 149.582 7.97265 151.069 9.4973C152.555 10.9838 153.299 13.2899 153.299 16.4154V18.8739C153.299 23.0286 151.927 25.6586 149.182 26.764V26.8783C150.707 27.3357 151.774 28.2696 152.384 29.6799C153.032 31.0902 153.356 32.9769 153.356 35.3401V42.3726C153.356 43.516 153.394 44.4499 153.47 45.1741C153.546 45.8602 153.737 46.5463 154.042 47.2324H147.638C147.41 46.5844 147.257 45.9745 147.181 45.4028C147.105 44.8311 147.067 43.8019 147.067 42.3154V34.9971C147.067 33.1675 146.762 31.8906 146.152 31.1664C145.58 30.4422 144.57 30.0801 143.122 30.0801H140.949V47.2324H134.66V7.21033ZM143.236 24.3626C144.494 24.3626 145.428 24.0386 146.038 23.3907C146.686 22.7427 147.01 21.6564 147.01 20.1317V17.0443C147.01 15.5959 146.743 14.5477 146.209 13.8997C145.714 13.2518 144.913 12.9278 143.808 12.9278H140.949V24.3626H143.236Z",
    fill: "#EB0014"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 7.21033H174.872V12.9278H164.009V23.505H172.642V29.2225H164.009V41.5149H174.872V47.2324H157.719V7.21033Z",
    fill: "#EB0014"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.264 30.1944L176.66 7.21033H183.35L187.638 21.9041H187.752L192.04 7.21033H198.158L190.554 30.1944V47.2324H184.264V30.1944Z",
    fill: "#EB0014"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.227 7.21033H211.746L218.264 47.2324H211.974L210.831 39.2851V39.3995H203.684L202.541 47.2324H196.709L203.227 7.21033ZM210.088 33.9679L207.286 14.1856H207.172L204.427 33.9679H210.088Z",
    fill: "#EB0014"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8179 50.4101H71.1763V65.4184H68.8179V50.4101ZM72.9426 50.4101H75.9014L78.1955 59.3936H78.2384V50.4101H80.3396V65.4184H77.9168L75.0867 54.4624H75.0438V65.4184H72.9426V50.4101ZM82.0925 50.4101H88.3316V52.5542H84.4509V56.735H87.4955V58.8791H84.4509V65.4184H82.0925V50.4101ZM92.8716 65.6328C91.7138 65.6328 90.8276 65.304 90.213 64.6465C89.5984 63.989 89.2911 63.06 89.2911 61.8593V53.9692C89.2911 52.7686 89.5984 51.8395 90.213 51.182C90.8276 50.5245 91.7138 50.1957 92.8716 50.1957C94.0294 50.1957 94.9156 50.5245 95.5302 51.182C96.1449 51.8395 96.4522 52.7686 96.4522 53.9692V61.8593C96.4522 63.06 96.1449 63.989 95.5302 64.6465C94.9156 65.304 94.0294 65.6328 92.8716 65.6328ZM92.8716 63.4888C93.6864 63.4888 94.0937 62.9956 94.0937 62.0094V53.8192C94.0937 52.8329 93.6864 52.3398 92.8716 52.3398C92.0569 52.3398 91.6495 52.8329 91.6495 53.8192V62.0094C91.6495 62.9956 92.0569 63.4888 92.8716 63.4888ZM99.8073 52.5542H97.3416V50.4101H104.631V52.5542H102.166V65.4184H99.8073V52.5542ZM105.773 50.4101H112.205V52.5542H108.132V56.5206H111.369V58.6647H108.132V63.2744H112.205V65.4184H105.773V50.4101ZM116.885 65.6328C115.756 65.6328 114.891 65.3112 114.291 64.668C113.705 64.0248 113.412 63.1171 113.412 61.9451V53.8835C113.412 52.7114 113.705 51.8038 114.291 51.1605C114.891 50.5173 115.756 50.1957 116.885 50.1957C118.015 50.1957 118.872 50.5173 119.458 51.1605C120.059 51.8038 120.359 52.7114 120.359 53.8835V55.4701H118.129V53.7334C118.129 52.8043 117.736 52.3398 116.95 52.3398C116.164 52.3398 115.77 52.8043 115.77 53.7334V62.1166C115.77 63.0314 116.164 63.4888 116.95 63.4888C117.736 63.4888 118.129 63.0314 118.129 62.1166V59.8225H120.359V61.9451C120.359 63.1171 120.059 64.0248 119.458 64.668C118.872 65.3112 118.015 65.6328 116.885 65.6328ZM121.77 50.4101H124.128V56.5206H126.658V50.4101H129.017V65.4184H126.658V58.6647H124.128V65.4184H121.77V50.4101ZM137.273 65.6328C136.129 65.6328 135.265 65.3112 134.679 64.668C134.092 64.0105 133.799 63.0742 133.799 61.8593V61.0017H136.029V62.0308C136.029 63.0028 136.437 63.4888 137.251 63.4888C137.652 63.4888 137.952 63.3744 138.152 63.1457C138.366 62.9027 138.473 62.5168 138.473 61.9879C138.473 61.359 138.331 60.8087 138.045 60.337C137.759 59.851 137.23 59.2722 136.458 58.6004C135.486 57.7427 134.807 56.9709 134.421 56.2848C134.035 55.5844 133.842 54.7983 133.842 53.9264C133.842 52.74 134.143 51.8252 134.743 51.182C135.343 50.5245 136.215 50.1957 137.359 50.1957C138.488 50.1957 139.338 50.5245 139.91 51.182C140.496 51.8252 140.789 52.7543 140.789 53.9692V54.591H138.559V53.8192C138.559 53.3046 138.459 52.9329 138.259 52.7043C138.059 52.4613 137.766 52.3398 137.38 52.3398C136.594 52.3398 136.201 52.8186 136.201 53.7763C136.201 54.3194 136.344 54.8268 136.63 55.2985C136.93 55.7702 137.466 56.342 138.238 57.0138C139.224 57.8714 139.903 58.6504 140.274 59.3508C140.646 60.0512 140.832 60.873 140.832 61.8164C140.832 63.0457 140.525 63.989 139.91 64.6465C139.31 65.304 138.431 65.6328 137.273 65.6328ZM144.224 59.0292L141.372 50.4101H143.881L145.489 55.9203H145.532L147.14 50.4101H149.434L146.582 59.0292V65.4184H144.224V59.0292ZM153.227 65.6328C152.084 65.6328 151.219 65.3112 150.633 64.668C150.047 64.0105 149.754 63.0742 149.754 61.8593V61.0017H151.984V62.0308C151.984 63.0028 152.391 63.4888 153.206 63.4888C153.606 63.4888 153.906 63.3744 154.107 63.1457C154.321 62.9027 154.428 62.5168 154.428 61.9879C154.428 61.359 154.285 60.8087 153.999 60.337C153.713 59.851 153.185 59.2722 152.413 58.6004C151.441 57.7427 150.762 56.9709 150.376 56.2848C149.99 55.5844 149.797 54.7983 149.797 53.9264C149.797 52.74 150.097 51.8252 150.697 51.182C151.298 50.5245 152.17 50.1957 153.313 50.1957C154.442 50.1957 155.293 50.5245 155.865 51.182C156.451 51.8252 156.744 52.7543 156.744 53.9692V54.591H154.514V53.8192C154.514 53.3046 154.414 52.9329 154.214 52.7043C154.014 52.4613 153.721 52.3398 153.335 52.3398C152.549 52.3398 152.155 52.8186 152.155 53.7763C152.155 54.3194 152.298 54.8268 152.584 55.2985C152.884 55.7702 153.42 56.342 154.192 57.0138C155.179 57.8714 155.857 58.6504 156.229 59.3508C156.601 60.0512 156.787 60.873 156.787 61.8164C156.787 63.0457 156.479 63.989 155.865 64.6465C155.264 65.304 154.385 65.6328 153.227 65.6328ZM159.983 52.5542H157.517V50.4101H164.807V52.5542H162.341V65.4184H159.983V52.5542ZM165.949 50.4101H172.381V52.5542H168.307V56.5206H171.545V58.6647H168.307V63.2744H172.381V65.4184H165.949V50.4101ZM173.738 50.4101H177.104L178.604 61.1518H178.647L180.148 50.4101H183.514V65.4184H181.285V54.055H181.242L179.526 65.4184H177.554L175.839 54.055H175.796V65.4184H173.738V50.4101ZM188.34 65.6328C187.197 65.6328 186.332 65.3112 185.746 64.668C185.16 64.0105 184.867 63.0742 184.867 61.8593V61.0017H187.097V62.0308C187.097 63.0028 187.504 63.4888 188.319 63.4888C188.719 63.4888 189.019 63.3744 189.219 63.1457C189.434 62.9027 189.541 62.5168 189.541 61.9879C189.541 61.359 189.398 60.8087 189.112 60.337C188.826 59.851 188.297 59.2722 187.526 58.6004C186.554 57.7427 185.875 56.9709 185.489 56.2848C185.103 55.5844 184.91 54.7983 184.91 53.9264C184.91 52.74 185.21 51.8252 185.81 51.182C186.411 50.5245 187.283 50.1957 188.426 50.1957C189.555 50.1957 190.406 50.5245 190.977 51.182C191.563 51.8252 191.856 52.7543 191.856 53.9692V54.591H189.627V53.8192C189.627 53.3046 189.527 52.9329 189.327 52.7043C189.126 52.4613 188.833 52.3398 188.447 52.3398C187.661 52.3398 187.268 52.8186 187.268 53.7763C187.268 54.3194 187.411 54.8268 187.697 55.2985C187.997 55.7702 188.533 56.342 189.305 57.0138C190.291 57.8714 190.97 58.6504 191.342 59.3508C191.714 60.0512 191.899 60.873 191.899 61.8164C191.899 63.0457 191.592 63.989 190.977 64.6465C190.377 65.304 189.498 65.6328 188.34 65.6328ZM196.685 50.4101H199.044V63.2744H202.925V65.4184H196.685V50.4101ZM204.056 50.4101H206.414V63.2744H210.295V65.4184H204.056V50.4101ZM211.426 50.4101H214.899C216.071 50.4101 216.95 50.7246 217.536 51.3535C218.122 51.9824 218.415 52.9044 218.415 54.1193V55.5987C218.415 56.8137 218.122 57.7356 217.536 58.3645C216.95 58.9934 216.071 59.3079 214.899 59.3079H213.784V65.4184H211.426V50.4101ZM214.899 57.1638C215.285 57.1638 215.571 57.0566 215.757 56.8422C215.957 56.6278 216.057 56.2634 216.057 55.7488V53.9692C216.057 53.4547 215.957 53.0902 215.757 52.8758C215.571 52.6614 215.285 52.5542 214.899 52.5542H213.784V57.1638H214.899Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3013 7.22748H68.1547L70.178 7.81959C77.8649 10.2514 84.1241 16.1132 86.2157 23.1589L84.0735 9.6908C83.7208 7.81917 82.637 7.28922 81.3013 7.22748Z",
    fill: "url(#paint0_linear_2026_9949)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8241 11.7919C70.2679 11.2975 67.5366 9.78646 68.97 8.6398C69.8971 7.89822 71.0095 9.93774 68.4139 11.7919C67.1158 12.7192 63.9637 16.6129 67.1158 19.5795C67.7356 20.1629 68.6915 20.1489 69.3408 19.7649",
    stroke: "url(#paint1_linear_2026_9949)",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1947 11.4211C70.6384 11.9156 69.4888 13.2012 69.3405 14.3878",
    stroke: "url(#paint2_linear_2026_9949)",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6719 4.58759C65.4469 6.13274 60.8071 11.7717 63.4073 17.7523C65.2615 22.0169 68.5991 22.0169 70.2677 20.9044",
    stroke: "url(#paint3_linear_2026_9949)",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.2611,
    cy: 10.7064,
    r: 0.556256,
    fill: "url(#paint4_linear_2026_9949)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9698,
    cy: 17.9107,
    r: 0.556256,
    fill: "url(#paint5_linear_2026_9949)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5592 14.3074L71.5592 8.35965",
    stroke: "url(#paint6_linear_2026_9949)",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3593 2.28158C68.1739 2.65242 68.1739 3.57951 69.1009 3.57951C70.028 3.57951 70.9552 2.28158 72.6239 1.16907",
    stroke: "url(#paint7_linear_2026_9949)",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4717 2.09611C70.028 1.35441 70.5842 0.983583 71.4224 0.612764",
    stroke: "#FE6222",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0296 6.62583C69.7216 6.01127 69.4495 4.51249 70.9962 4.29366C72.5274 4.07703 72.7149 5.81863 72.2066 6.39151L71.5785 7.05501",
    stroke: "url(#paint8_linear_2026_9949)",
    strokeWidth: 0.637256,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.1 3.0962H218.383V2.4722H220.504V3.0962H219.787V6.84021H219.1V3.0962ZM220.837 2.4722H221.816L222.253 5.59845H222.266L222.702 2.4722H223.682V6.84021H223.033V3.53301H223.021L222.521 6.84021H221.947L221.448 3.53301H221.436V6.84021H220.837V2.4722Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2026_9949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 61,
    height: 59
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2234 6.99994L54.4676 64.9895H47.5056L28.5852 14.781L30.2234 6.99994ZM12.6135 59.5018C12.2313 60.5939 12.1767 61.5221 12.4497 62.2866C12.7228 63.0511 13.1596 63.6517 13.7602 64.0885C14.4155 64.4708 15.0707 64.6619 15.726 64.6619H16.4631V65.4809H0V64.6619C0 64.6619 0.13651 64.6619 0.409531 64.6619C0.627947 64.6619 0.737155 64.6619 0.737155 64.6619C1.99305 64.6619 3.27625 64.2796 4.58674 63.5152C5.95185 62.6961 7.07123 61.3583 7.9449 59.5018H12.6135ZM30.2234 6.99994L30.9605 12.7334L10.4021 65.2352H5.48771L26.4557 15.4363C26.4557 15.4363 26.5922 15.1087 26.8652 14.4534C27.1928 13.7435 27.5478 12.8972 27.93 11.9143C28.3668 10.9314 28.7218 9.97586 28.9948 9.0476C29.3224 8.11932 29.4862 7.43677 29.4862 6.99994H30.2234ZM45.4579 59.5018H52.1742C52.9933 61.3583 54.0854 62.6961 55.4505 63.5152C56.8156 64.2796 58.1261 64.6619 59.382 64.6619C59.382 64.6619 59.4912 64.6619 59.7096 64.6619C59.928 64.6619 60.0372 64.6619 60.0372 64.6619V65.4809H41.6083V64.6619H42.3455C43.383 64.6619 44.3112 64.225 45.1303 63.3514C45.9494 62.4231 46.0586 61.1399 45.4579 59.5018Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7304 60.0666H11.8806L29.7807 10.4849L46.7304 60.0666Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2026_9949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1262 35.8665L-2.30283 68.7247H15.3935L29.5917 35.8665L38.2883 18.4728L30.5558 3.00764L14.1262 35.8665Z",
    fill: "url(#paint9_linear_2026_9949)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6449 18.8586L42.8521 70.0587L64.155 70.6662L30.9789 3.70914L22.6449 18.8586Z",
    fill: "url(#paint10_linear_2026_9949)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0818 10.7932L54.004 70.3821L64.155 70.6662L30.9789 3.70914L27.0818 10.7932Z",
    fill: "url(#paint11_linear_2026_9949)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.9696,
    y: 28.5436,
    width: 12.3558,
    height: 2.21771,
    rx: 0.475224,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8005 32.7698H22.4942C22.7453 32.4183 22.9336 31.2843 22.9964 30.7613L23.4357 31.4517L23.8437 30.7613L24.3772 31.4517L24.7852 30.7613L25.2873 31.4517L25.7894 30.7613L26.2288 31.4517L26.6368 30.7613L27.0761 31.4517L27.5469 30.7613L27.9548 31.4517L28.457 30.7613L28.8963 31.4517L29.2729 30.7613L29.6809 31.4517L30.0575 30.7613L30.4654 31.4517L30.842 30.7613L31.25 31.4517L31.6266 30.7613L32.0973 31.4517L32.5053 30.7613L32.9761 31.4517L33.5096 30.7613L34.0117 31.4517L34.4197 30.7613L34.859 31.3576L35.3298 30.7613C35.4051 31.9413 35.675 32.592 35.8005 32.7698Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6719 35.0413H21.6231C21.9071 34.6438 22.12 33.3613 22.191 32.7698L22.6879 33.5506L23.1493 32.7698L23.7527 33.5506L24.2141 32.7698L24.782 33.5506L25.3498 32.7698L25.8467 33.5506L26.3081 32.7698L26.805 33.5506L27.3374 32.7698L27.7988 33.5506L28.3667 32.7698L28.8636 33.5506L29.2895 32.7698L29.7509 33.5506L30.1768 32.7698L30.6382 33.5506L31.0641 32.7698L31.5255 33.5506L31.9514 32.7698L32.4838 33.5506L32.9452 32.7698L33.4776 33.5506L34.081 32.7698L34.6488 33.5506L35.1102 32.7698L35.6071 33.4441L36.1395 32.7698C36.2247 34.1043 36.5299 34.8402 36.6719 35.0413Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5431 37.5757H20.7519C21.0687 37.1322 21.3063 35.7012 21.3855 35.0412L21.9399 35.9124L22.4547 35.0412L23.128 35.9124L23.6428 35.0412L24.2764 35.9124L24.9101 35.0412L25.4645 35.9124L25.9793 35.0412L26.5338 35.9124L27.1278 35.0412L27.6426 35.9124L28.2762 35.0412L28.8307 35.9124L29.3059 35.0412L29.8207 35.9124L30.2959 35.0412L30.8108 35.9124L31.286 35.0412L31.8008 35.9124L32.276 35.0412L32.8701 35.9124L33.3849 35.0412L33.9789 35.9124L34.6522 35.0412L35.2858 35.9124L35.8006 35.0412L36.3551 35.7936L36.9491 35.0412C37.0441 36.5302 37.3847 37.3513 37.5431 37.5757Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3353 40.3496H19.96C20.3067 39.8642 20.5667 38.2982 20.6534 37.5759L21.2601 38.5294L21.8235 37.5759L22.5603 38.5294L23.1237 37.5759L23.8171 38.5294L24.5105 37.5759L25.1172 38.5294L25.6806 37.5759L26.2873 38.5294L26.9374 37.5759L27.5008 38.5294L28.1942 37.5759L28.801 38.5294L29.321 37.5759L29.8844 38.5294L30.4045 37.5759L30.9679 38.5294L31.4879 37.5759L32.0513 38.5294L32.5714 37.5759L33.2214 38.5294L33.7848 37.5759L34.4349 38.5294L35.1716 37.5759L35.8651 38.5294L36.4285 37.5759L37.0352 38.3994L37.6853 37.5759C37.7893 39.2054 38.162 40.104 38.3353 40.3496Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2854 43.4101H19.0092C19.3918 42.8745 19.6787 41.1465 19.7743 40.3495L20.4438 41.4016L21.0655 40.3495L21.8785 41.4016L22.5001 40.3495L23.2653 41.4016L24.0304 40.3495L24.6999 41.4016L25.3216 40.3495L25.9911 41.4016L26.7084 40.3495L27.3301 41.4016L28.0952 40.3495L28.7647 41.4016L29.3386 40.3495L29.9603 41.4016L30.5341 40.3495L31.1558 41.4016L31.7297 40.3495L32.3513 41.4016L32.9252 40.3495L33.6425 41.4016L34.2642 40.3495L34.9815 41.4016L35.7945 40.3495L36.5596 41.4016L37.1813 40.3495L37.8508 41.2581L38.5681 40.3495C38.6829 42.1476 39.0941 43.1391 39.2854 43.4101Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3151 46.7814H17.9796C18.401 46.1914 18.717 44.2879 18.8224 43.41L19.5599 44.5689L20.2447 43.41L21.1402 44.5689L21.8251 43.41L22.6679 44.5689L23.5108 43.41L24.2483 44.5689L24.9331 43.41L25.6706 44.5689L26.4607 43.41L27.1456 44.5689L27.9884 43.41L28.7259 44.5689L29.358 43.41L30.0429 44.5689L30.675 43.41L31.3598 44.5689L31.9919 43.41L32.6768 44.5689L33.3089 43.41L34.0991 44.5689L34.7839 43.41L35.5741 44.5689L36.4696 43.41L37.3124 44.5689L37.9973 43.41L38.7347 44.4109L39.5249 43.41C39.6513 45.3907 40.1044 46.4829 40.3151 46.7814Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8992 50.6311H16.3955C16.8767 49.9574 17.2376 47.784 17.3579 46.7815L18.2 48.1048L18.982 46.7815L20.0046 48.1048L20.7865 46.7815L21.7489 48.1048L22.7113 46.7815L23.5534 48.1048L24.3354 46.7815L25.1775 48.1048L26.0797 46.7815L26.8617 48.1048L27.8241 46.7815L28.6662 48.1048L29.388 46.7815L30.1699 48.1048L30.8917 46.7815L31.6737 48.1048L32.3955 46.7815L33.1775 48.1048L33.8993 46.7815L34.8015 48.1048L35.5835 46.7815L36.4857 48.1048L37.5083 46.7815L38.4707 48.1048L39.2526 46.7815L40.0947 47.9243L40.997 46.7815C41.1413 49.0431 41.6586 50.2903 41.8992 50.6311Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7804 55.0484H14.5145C15.0667 54.2754 15.4809 51.7813 15.6189 50.6309L16.5852 52.1494L17.4825 50.6309L18.6559 52.1494L19.5532 50.6309L20.6576 52.1494L21.762 50.6309L22.7283 52.1494L23.6256 50.6309L24.5919 52.1494L25.6273 50.6309L26.5246 52.1494L27.629 50.6309L28.5953 52.1494L29.4236 50.6309L30.3209 52.1494L31.1491 50.6309L32.0465 52.1494L32.8747 50.6309L33.772 52.1494L34.6003 50.6309L35.6357 52.1494L36.533 50.6309L37.5683 52.1494L38.7417 50.6309L39.8461 52.1494L40.7434 50.6309L41.7097 51.9424L42.7451 50.6309C42.9107 53.2262 43.5043 54.6573 43.7804 55.0484Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6361 60.0668H12.4511C13.402 57.7699 13.2436 56.3686 13.402 55.0485L14.5109 56.791L15.5405 55.0485L16.887 56.791L17.9166 55.0485L19.1839 56.791L20.4512 55.0485L21.56 56.791L22.5897 55.0485L23.6985 56.791L24.8866 55.0485L25.9162 56.791L27.1835 55.0485L28.2924 56.791L29.2428 55.0485L30.2725 56.791L31.2229 55.0485L32.2526 56.791L33.203 55.0485L34.2327 56.791L35.1831 55.0485L36.3712 56.791L37.4008 55.0485L38.5889 56.791L39.9354 55.0485L41.2026 56.791L42.2323 55.0485L43.3411 56.5534L44.5292 55.0485C44.6064 58.0075 44.6856 58.1659 45.6361 60.0668Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9199 27.1178L23.9199 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8704 27.1178L24.8704 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8209 27.1178L25.8209 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7712 27.1178L26.7712 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7216 27.1178L27.7216 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6721 27.1178L28.6721 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6226 27.1178L29.6226 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5731 27.1178L30.5731 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5234 27.1178L31.5234 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.474 27.1178L32.474 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4245 27.1178L33.4245 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3748 27.1178L34.3748 28.5435",
    stroke: "white",
    strokeWidth: 0.475224,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8211,
    y: 55.0451,
    width: 6.65314,
    height: 10.4549,
    fill: "#EC0115"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0384 31.8702H28.9096L28.8304 32.8206H27.9592L28.0384 31.8702Z",
    fill: "#EC0115"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7238 31.859L29.8527 31.8418L29.9131 32.7937L30.7842 32.8109L30.7238 31.859Z",
    fill: "#FF3619"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.88 33.9296H28.8304L28.672 35.0385H27.7216L27.88 33.9296Z",
    fill: "#EC0115"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8412 33.9209L29.8909 33.9022L30.0274 35.014L30.9777 35.0327L30.8412 33.9209Z",
    fill: "#FF3419"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7217 36.1473H28.6721L28.5137 37.573H27.5633L27.7217 36.1473Z",
    fill: "#FF3119"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9561 36.1414L30.0058 36.1227L30.1422 37.5699L31.0863 37.5699L30.9561 36.1414Z",
    fill: "#FF3119"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4049 38.84H28.3554L28.197 40.4241H27.2465L27.4049 38.84Z",
    fill: "#FF1C15"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2195 38.8403L30.2692 38.8216L30.3963 40.4085L31.3466 40.4272L31.2195 38.8403Z",
    fill: "#FF2E18"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1516 41.5328H28.102L27.9436 43.4337H26.9932L27.1516 41.5328Z",
    fill: "#FF2717"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4203 41.5377L30.4701 41.519L30.5909 43.4226L31.5412 43.4414L31.4203 41.5377Z",
    fill: "#FF2B17"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8505 44.8912H27.8801L27.7217 46.7921H26.6921L26.8505 44.8912Z",
    fill: "#FF3319"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6544 44.901L30.6249 44.8807L30.7458 46.7844L31.7753 46.8047L31.6544 44.901Z",
    fill: "#FF2917"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5333 48.4238H27.8006L27.563 50.6415H26.2957L26.5333 48.4238Z",
    fill: "#FF431C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9014 48.4392L30.6344 48.4142L30.8282 50.6362L32.0952 50.6612L31.9014 48.4392Z",
    fill: "#FF2516"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1379 52.463H27.722L27.4844 55.156H25.8211L26.1379 52.463Z",
    fill: "#EC0115"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2181 52.4856L30.6343 52.4544L30.8188 55.1515L32.4817 55.1843L32.2181 52.4856Z",
    fill: "#EC0115"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2026_9949",
    x1: 76.2177,
    y1: 17.7902,
    x2: 84.2805,
    y2: 7.26229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000974715,
    stopColor: "#FF1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589326,
    stopColor: "#FD6B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2026_9949",
    x1: 69.0784,
    y1: 8.53301,
    x2: 68.9873,
    y2: 20.0586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FE6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2026_9949",
    x1: 70.5556,
    y1: 11.4338,
    x2: 70.5392,
    y2: 14.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FE6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2026_9949",
    x1: 67.638,
    y1: 4.66006,
    x2: 67.508,
    y2: 21.5601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FE6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2026_9949",
    x1: 65.3888,
    y1: 10.7352,
    x2: 64.9203,
    y2: 9.58364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00097469,
    stopColor: "#FF1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395062,
    stopColor: "#FD6B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2026_9949",
    x1: 69.0975,
    y1: 17.9395,
    x2: 68.629,
    y2: 16.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00097469,
    stopColor: "#FF1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395062,
    stopColor: "#FD6B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2026_9949",
    x1: 71.9772,
    y1: 9.47017,
    x2: 72.4084,
    y2: 13.7164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FE6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2026_9949",
    x1: 71.1207,
    y1: 1.17938,
    x2: 71.1161,
    y2: 3.58399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FE6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2026_9949",
    x1: 71.7191,
    y1: 4.33766,
    x2: 71.3367,
    y2: 7.02658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FE6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2026_9949",
    x1: 22.6532,
    y1: 34.1649,
    x2: -13.7677,
    y2: 89.4581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00097469,
    stopColor: "#FF1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395062,
    stopColor: "#FD6B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2026_9949",
    x1: 28.4728,
    y1: 62.8573,
    x2: 60.599,
    y2: 2.86728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999025,
    stopColor: "#FD6B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01F25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2026_9949",
    x1: 33.1377,
    y1: 8.83311,
    x2: 61.6962,
    y2: 69.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999025,
    stopColor: "#EB0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0014"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAatreya);
export default __webpack_public_path__ + "static/media/aatreya.410bcdcaaaf521ba68eaec13c30d0452.svg";
export { ForwardRef as ReactComponent };